
import * as React from 'react';
import { UIComponentViewImpl } from '../../uicomponentview';
import { UIDataModel } from '../../uicomponent';
import { LanguageComponentProps, LanguageComponentState, LanguageComponentHandler } from './languagecomponent';
import { LanguageCSSStyle } from './languagecss';
import { LanguageConst } from '../../../../utils/resources/languageconst';
// import { Strings } from '../../../../utils/resources/strings';

import './language-selection-style.css';

export class LanguageViewImpl extends UIComponentViewImpl<UIDataModel>
{
    draw(props: LanguageComponentProps, state: LanguageComponentState, cssStyle: LanguageCSSStyle): JSX.Element | boolean
    {

       if(props.fontSize !== undefined){
            return (
                <div style={cssStyle.getLanguageContainerCSSStyle()}>
                    <div style={cssStyle.getTitleDivCSSStyle()} onClick={state.languageSelected === LanguageConst.ENGLISH ? () =>{} : () => (this.getUIComponentHandler() as LanguageComponentHandler).onLangaugeSelected(LanguageConst.ENGLISH)}>
                        <label style={Object.assign(cssStyle.getTitleCSSStyle(state.languageSelected === LanguageConst.ENGLISH), {fontSize: props.fontSize, paddingLeft: "16px", paddingRight: "8px",})}>{"EN"}</label>
                    </div>
                    <div style={cssStyle.getPipeCSSStyle()}>
                        {"|"}
                    </div>
                    <div style={cssStyle.getTitleDivCSSStyle()} onClick={state.languageSelected === LanguageConst.FRENCH ? () =>{} : () => (this.getUIComponentHandler() as LanguageComponentHandler).onLangaugeSelected(LanguageConst.FRENCH)}>
                        <label style={Object.assign(cssStyle.getTitleCSSStyle(state.languageSelected === LanguageConst.FRENCH), {fontSize: props.fontSize,  paddingLeft: "8px", paddingRight: "16px",})}>{"FR"}</label>
                    </div>
                </div>
            );
       } else{

        return (
            <div style={cssStyle.getLanguageContainerCSSStyle()}>
                <div style={cssStyle.getTitleDivCSSStyle()} onClick={state.languageSelected === LanguageConst.ENGLISH ? () =>{} : () => (this.getUIComponentHandler() as LanguageComponentHandler).onLangaugeSelected(LanguageConst.ENGLISH)}>
                    <label className="language-selection-label" style={Object.assign(cssStyle.getTitleCSSStyle(state.languageSelected === LanguageConst.ENGLISH), {fontSize: props.fontSize, paddingLeft: "16px", paddingRight: "8px",})}>{"EN"}</label>

                </div>
                <div style={cssStyle.getPipeCSSStyle()}>
                    {"|"}
                </div>
                <div style={cssStyle.getTitleDivCSSStyle()} onClick={state.languageSelected === LanguageConst.FRENCH ? () =>{} : () => (this.getUIComponentHandler() as LanguageComponentHandler).onLangaugeSelected(LanguageConst.FRENCH)}>
                <label className="language-selection-label" style={Object.assign(cssStyle.getTitleCSSStyle(state.languageSelected === LanguageConst.FRENCH), {fontSize: props.fontSize,  paddingLeft: "8px", paddingRight: "16px",})}>{"FR"}</label>

                </div>
            </div>
        );
       }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/header/language/languageview.tsx